"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var symbolSupported = typeof Symbol === "function";

var HYDRATE = exports.HYDRATE = symbolSupported ? Symbol("__hydrate__") : "__hydrate__";


//////////////////
// WEBPACK FOOTER
// ./node_modules/freactal/lib/common.js
// module id = 329
// module chunks = 0